module.exports = __webpack_public_path__ + "img/hr-green-small-grass-08.67a8aeca.png";